import React from "react"
import tw, { styled } from "twin.macro"
import { Link } from "gatsby"

import PromoData from "./PromoData"
import ContentContainer from "./ContentContainer"
import ContentBiggerText from "./ContentBiggerText"
import ContentSmallerText from "./ContentSmallerText"
import CouseTermsList from "./CouseTermsList"
import Team from "./Team"
import Layout from "./Layout"
import Faq from "./Faq"
import CourseTermsWrapper from "./CourseTermsWrapper"

import * as utils from "../utils"

const SignupInnerContainer = styled.div`
  ${tw`max-w-screen-xl mx-auto lg:flex lg:items-center lg:justify-between xl:rounded-lg shadow-sm overflow-hidden bg-gradient-to-r from-blue-800 to-blue-600`}
`

const ExtendedTermsWrapper = styled.div`
  ${tw`flex-grow py-12 px-10 text-white lg:w-6/12 text-center lg:text-left`}
`

const CourseData = styled.div`
  ${tw`flex-grow py-12 px-10 lg:w-6/12 text-gray-300 text-center lg:text-left`}
`

const SubHeader = styled.h3`
  ${tw`text-3xl text-center leading-8 font-extrabold tracking-tight sm:text-4xl sm:leading-10 my-6`}
`

const SignupContainer = styled.div`
  ${tw``}
`

const SignupData = styled.div`
  ${tw`text-xl mt-4`}
`

const SingupHeader = styled.h2`
  ${tw`text-3xl leading-9 tracking-tight md:text-4xl md:leading-10`}
`

const SingupHeaderText = styled.span`
  ${tw`block font-bold`}
`

const SingupHeaderTextHighlight = styled.span`
  ${tw`block text-white font-extrabold`}
`

const CtaContainer = styled.div`
  ${tw`mt-8 flex lg:flex-shrink-0 justify-center lg:justify-start`}
`

const CtaButton = styled.div`
  ${tw`inline-flex rounded-md shadow`}
`

const CtaLink = styled(Link)`
  ${tw`inline-flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-red-600 hover:bg-red-700 transition duration-150 ease-in-out`}
`

const HeroContainer = styled.div`
  ${tw`mt-10 mx-auto max-w-screen-xl px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 xl:mt-28 mb-10`}
`

const CourseGrid = styled.div`
  ${tw`grid grid-cols-1 gap-4 sm:grid-cols-2`}
`

const HeroInnerContainer = styled.div`
  ${tw`text-center`}
`

const HeroHeader = styled.h1`
  ${tw`text-4xl tracking-tight leading-10 font-extrabold text-gray-900 sm:text-5xl sm:leading-none md:text-6xl`}
`

const HeroDescription = styled.p`
  ${tw`mt-3 max-w-md mx-auto text-base text-gray-500 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl`}
`

const Highlight = styled.span`
  ${tw`text-blue-700`}
`

const Br = styled.br`
  ${tw``}
`

const TermsHeader = styled.h4`
  ${tw`text-lg leading-6 font-bold`}
`

const PriceSpan = styled.strong`
  ${tw`font-extrabold text-white`}
`

const NetPrice = styled.div`
  ${tw`text-sm`}
`

const NewGrossPrice = styled.span`
  ${tw`line-through`}
`

const PromoInfo = styled.p`
${tw`text-sm mt-2 text-white font-bold`}
`

export default function Home({
  title,
  subtitle,
  hours,
  grossPrice,
  newGrossPrice,
  netPrice,
  children,
  id,
}) {
  return (
    <Layout>
      <HeroContainer>
        <HeroInnerContainer>
          <HeroHeader>
            {title}
            <Br />
            <Highlight> {subtitle}</Highlight>
          </HeroHeader>
          <HeroDescription>
            Indywidualny kurs on-line lub stacjonarny <strong>Wrocławiu</strong>
          </HeroDescription>
        </HeroInnerContainer>
      </HeroContainer>
      <SignupContainer>
        <SignupInnerContainer>
          <CourseData>
            <CourseGrid>
            <SingupHeader>
              <SingupHeaderText>{title}</SingupHeaderText>
              <SingupHeaderTextHighlight>{subtitle}</SingupHeaderTextHighlight>
            </SingupHeader>
            <SignupData>
              {hours} {utils.getHoursPhrase(hours)},{" "}
              {newGrossPrice !== grossPrice && <NewGrossPrice>{newGrossPrice}{'\u00A0'}</NewGrossPrice>}
              <PriceSpan>{grossPrice}</PriceSpan> zł
              <NetPrice>{netPrice} zł netto</NetPrice>
              {newGrossPrice !== grossPrice && <PromoInfo>Niższa cena tylko do 11 września!</PromoInfo>}
            </SignupData>
            </CourseGrid>
            <CtaContainer>
              <CtaButton>
                <CtaLink to="/kontakt">
                  Napisz do nas
                </CtaLink>
              </CtaButton>
            </CtaContainer>
          </CourseData>
        </SignupInnerContainer>
      </SignupContainer>
      <ContentContainer>{children}</ContentContainer>
      <ContentContainer>
        <ContentBiggerText
          header="Jesteś w dobrych rękach"
          text="Zajęcia są prowadzone indywidualnie."
        />
        <ContentSmallerText text="Każdy z uczestników kursu otrzymuje zbiór niezbędnych aktów prawnych, druków oraz autorskie materiały merytoryczne. Każdy z wymienionych kursów kończy się egzaminem. Cena zawiera wszystkie opłaty związane z kursem, a więc: wykłady, materiały teoretyczne oraz ćwiczenia, egzamin oraz zaświadczenie o ukończeniu kursu. Uczestnicy kursu otrzymują imienne zaświadczenie o ukończenia szkolenia zawierające informacje o ilości godzin z poszczególnego zakresu materiału, ilości godzin teorii oraz praktyki. " />
      </ContentContainer>
      <Faq />
      <PromoData />
      <Team />
      <SubHeader>Inne kursy</SubHeader>
      <CourseTermsWrapper>
        <CouseTermsList />
      </CourseTermsWrapper>
    </Layout>
  )
}
